// @flow

import * as React from 'react';
import { MountedClientOnly } from '@ta/common.client';
import { RouteConsumer, Match, type Route, type NavigateFunc } from '@ta/common.routing';
import ModalView, { type OuterProps as ViewProps } from './ModalView';

type ExternalProps = {|
  /** The path that must match to display the modal */
  path: { [string]: string },
  /** Any additional props for Modal */
  ...ViewProps,
|};

type Props = {|
  /** The externally-visible interface for consumers of this component */
  ...ExternalProps,
  /** provided by RouteConsumer */
  route: Route,
  /** provided by RouteConsumer */
  navigate: NavigateFunc,
|};

/** The base, uncontrolled component of a RoutedModal */
/**
 * @deprecated  Use @ta/modal.styleguide instead
 */
class RoutedModal extends React.Component<Props> {
  closeModal = /* istanbul ignore next */ () => {
    const { path, navigate, route, onClose } = this.props;

    // eslint-disable-next-line no-restricted-globals
    if (window?.history?.state) {
      navigate(route, { reset: true });
    } else {
      const newRoute = { ...route };
      Object.keys(path).forEach(key => {
        delete newRoute[key];
      });
      navigate(newRoute);
    }

    // The else path is silly to test
    /* istanbul ignore next */
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { path, route, navigate, onClose, ...viewProps } = this.props;
    return (
      <Match {...path}>
        <ModalView onClose={this.closeModal} {...viewProps} />
      </Match>
    );
  }
}

// Exposed for testing purposes only
export { RoutedModal as BaseRoutedModal };

/* istanbul ignore next */
const RoutedModalWithRouter = /* istanbul ignore next */ ({
  path,
  ...viewProps
}: ExternalProps) => (
  <RouteConsumer>
    {({ route, navigate }) => (
      <MountedClientOnly>
        <RoutedModal {...viewProps} path={path} route={route} navigate={navigate} />
      </MountedClientOnly>
    )}
  </RouteConsumer>
);

export default RoutedModalWithRouter;
